import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const kpiOptions = [
  "CTR",
  "CPM",
  "CPC",
  "ROAS",
  "CPV",
  "VTR"
];

const attributionModels = [
  "2025_02_14",
  "2025_02_07",
  "2025_01_31",
  "2025_01_24",
  "2025_01_17",
  "2025_01_10",
  "2025_01_03",
  "2024_12_27",
  "2024_12_20",
];

const defaultAudiences = [
  "Sports Enthusiasts",
  "Holiday Shoppers",
  "Young Professionals",
  "Tech Early Adopters",
  "Entertainment Seekers"
];

export function CreateScenarioModal({ isOpen, onClose, onAdd }) {
  const navigate = useNavigate();
  const [scenarioData, setScenarioData] = useState({
    name: '',
    startDate: '',
    endDate: '',
    kpi: 'CTR',
    budget: '',
    audience: '',
    attributionModel: ''
  });
  const [datesEntered, setDatesEntered] = useState(false);

  useEffect(() => {
    if (scenarioData.name && scenarioData.startDate && scenarioData.endDate) {
      setScenarioData(prev => {
        // Only update if not already set
        if (!prev.attributionModel) {
          const randomModel = attributionModels[Math.floor(Math.random() * attributionModels.length)];
          const minBudget = 500000;
          const maxBudget = 2000000;
          const steps = (maxBudget - minBudget) / 50000;
          const randomStep = Math.floor(Math.random() * (steps + 1));
          const randomBudget = minBudget + (randomStep * 50000);
          const randomAudience = defaultAudiences[Math.floor(Math.random() * defaultAudiences.length)];
          
          return { 
            ...prev, 
            attributionModel: randomModel,
            budget: randomBudget,
            audience: randomAudience
          };
        }
        return prev;
      });
      setDatesEntered(true);
    }
  }, [scenarioData.name, scenarioData.startDate, scenarioData.endDate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newScenario = {
      id: Date.now(),
      ...scenarioData,
      modelName: scenarioData.attributionModel,
      status: 'Draft',
      optionsCount: 0
    };
    
    onAdd(newScenario);
    onClose();
    
    navigate(`/partners/display/optimize/scenario/${newScenario.id}`, {
      state: { scenarioData: newScenario }
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Create New Scenario</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Scenario Name</label>
            <input
              type="text"
              value={scenarioData.name}
              onChange={(e) => setScenarioData({...scenarioData, name: e.target.value})}
              placeholder="Enter scenario name"
              required
            />
          </div>

          <div className="form-group">
            <label>Time Period</label>
            <div className="date-inputs">
              <input
                type="date"
                value={scenarioData.startDate}
                onChange={(e) => setScenarioData({...scenarioData, startDate: e.target.value})}
                required
              />
              <span>to</span>
              <input
                type="date"
                value={scenarioData.endDate}
                onChange={(e) => setScenarioData({...scenarioData, endDate: e.target.value})}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>KPI</label>
            <select
              value={scenarioData.kpi}
              onChange={(e) => setScenarioData({...scenarioData, kpi: e.target.value})}
              required
            >
              {kpiOptions.map((kpi, index) => (
                <option key={index} value={kpi}>{kpi}</option>
              ))}
            </select>
          </div>

          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose}>
              Cancel
            </button>
            <button 
              type="submit" 
              className="button-primary"
              disabled={!datesEntered}
            >
              Create Scenario
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 